/** @returns {"android"|"ios"|"other"} */
export function getMobilePlatform() {
  if (typeof navigator === "undefined") return "other";
  const ua = navigator.userAgent || navigator.vendor || window.opera || "";

  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
    return "ios";
  }
  return "other";
}
